/**
 * @file API service — calorificValuesPublicService.
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";

/** Public list item (active rows only, ordered by sortOrder on the server). */
export interface CalorificValuePublic {
  id: number;
  fuelMix: string;
  unit: string;
  calorificValue: string | null;
  sortOrder: number;
}

/** Exported function — fetch Active Calorific Values. */
export async function fetchActiveCalorificValues(): Promise<CalorificValuePublic[]> {
  const res = await axiosClient.get<{
    success?: boolean;
    data?: CalorificValuePublic[];
    message?: string;
  }>(API_URLS.CALORIFIC_VALUES);

  if (res.data?.success === false) {
    throw new Error(res.data.message || "Failed to load calorific values");
  }
  const data = res.data?.data;
  if (!Array.isArray(data)) return [];
  return [...data].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
}
